import {Box, Button} from '@material-ui/core';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import React, {useEffect, useRef, useState} from 'react';
import csx from 'classnames';
import {useCommonModalStyles} from '@/Agent/Quotes/InstantAppModalPages/common/modalStyles';

type StickyTopNavigationProps = {
    onExit?: () => void;
};

const StickyTopNavigation: React.FC<StickyTopNavigationProps> = ({onExit}) => {
    const [hasShadow, setHasShadow] = useState(false);
    const stickyHeaderRef = useRef(null);
    const classes = useCommonModalStyles();

    useEffect(() => {
        if (!stickyHeaderRef.current) return;

        const observer = new IntersectionObserver(([entry]) => setHasShadow(!entry.isIntersecting), {
            rootMargin: '-10px 0px 0px 0px',
        });

        observer.observe(stickyHeaderRef.current);

        return () => observer.disconnect();
    }, []);

    return (
        <>
            <div ref={stickyHeaderRef} />
            <Box className={csx(classes.stickyNav, {[classes.stickyBorder]: hasShadow})}>
                <Button color="primary" variant="text" onClick={onExit} startIcon={<KeyboardBackspaceIcon />}>
                    Save and exit
                </Button>
            </Box>
        </>
    );
};

export default StickyTopNavigation;
